import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "navbar"
};
const _hoisted_2 = {
  class: "input_main_phone"
};
const _hoisted_3 = {
  key: 1,
  class: "money_change"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "button_recharge"
};
const _hoisted_6 = {
  class: "button_real"
};
const _hoisted_7 = {
  key: 2,
  style: {
    "text-align": "center",
    "color": "grey",
    "padding": "10px 0"
  }
};
const _hoisted_8 = {
  key: 3,
  style: {
    "text-align": "center",
    "color": "red",
    "padding": "10px 0"
  }
};
const _hoisted_9 = {
  key: 4,
  style: {
    "text-align": "center",
    "color": "grey",
    "padding": "10px 0"
  }
};
const _hoisted_10 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_notice_bar = _resolveComponent("van-notice-bar");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_cell_group, {
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_notice_bar, {
      "left-icon": "volume-o",
      text: "话费电费充值活动开启。地区,运营商,不同价格不同,开卡即享最低92折优惠。充值有任何问题请联系客服。"
    }), _createVNode(_component_van_tabs, {
      class: "main-div"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_tab, {
        title: "话费充值",
        name: "a"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_divider), _createVNode(_component_van_form, {
          onSubmit: $setup.telSubmit
        }, {
          default: _withCtx(() => [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              modelValue: $setup.telephone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.telephone = $event),
              label: "手机号",
              placeholder: "请输入正确的手机号",
              type: "tel",
              rules: [{
                required: true,
                message: '请填写手机号'
              }, {
                pattern: /^1[3-9]\d{9}$/,
                message: '手机号格式错误'
              }]
            }, null, 8, ["modelValue"]), $setup.address ? (_openBlock(), _createBlock(_component_van_field, {
              key: 0,
              modelValue: $setup.address,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.address = $event),
              label: "运营商",
              readonly: ""
            }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_van_divider), $setup.currentPriceOptions.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentPriceOptions, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["button_layout", {
                  active: $setup.active_num === index + 1
                }]),
                onClick: $event => $setup.onSwitch(index + 1),
                key: item.rechargePrice
              }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item['rechargePrice']), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item['payPrice']), 1)], 10, _hoisted_4);
            }), 128))])) : $setup.telephone && !$setup.address ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 正在识别运营商... ")) : $setup.telephone && $setup.address && $setup.currentPriceOptions.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂不支持该运营商或面额 ")) : (_openBlock(), _createElementBlock("div", _hoisted_9, " 请输入手机号以查看充值选项 "))]),
            _: 1
          }), $setup.selectedPriceItem ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_van_cell_group, {
            style: {
              "font-size": "14px",
              "margin-top": "15px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_van_cell, {
              title: "我的抵扣额度",
              value: $setup.wallet + '元'
            }, null, 8, ["value"]), _createVNode(_component_van_cell, {
              title: "可抵扣",
              value: '-' + $setup.deductibleAmount + '元'
            }, null, 8, ["value"])]),
            _: 1
          })])) : _createCommentVNode("", true), _createVNode(_component_van_button, {
            type: "primary",
            style: {
              "width": "95%",
              "margin": "20px auto"
            },
            block: "",
            "native-type": "submit",
            disabled: !$setup.selectedPriceItem
          }, {
            default: _withCtx(() => [_createTextVNode(" 立即充值 " + _toDisplayString($setup.selectedPriceItem ? '(' + $setup.finalPayAmount + '元)' : ''), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }, 8, ["onSubmit"])]), _cache[2] || (_cache[2] = _createElementVNode("div", null, [_createElementVNode("div", {
          class: "amount"
        }, [_createElementVNode("div", {
          class: "amount_tit"
        }, "请伙伴们一定知晓："), _createElementVNode("div", {
          class: "content inslow",
          style: {}
        }, [_createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "1，在本系统下单电费/话费期间，请不要在其他的平台同时充值，否则出现问题无法售后！"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "2，虚拟运营商号码（比如170/171开头）空号/停机/副卡/欠费的，不支持充值！"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "3，充值后，一般1-48小时到账，极个别的可能会出现分批到账，如充值失败或部分充值或超过72小时,款项会原路退回。"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "4、本服务为代充值服务，没有发票，介意请勿充值！"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "5，如果有绑定代扣自动充值服务的号码，请提前解除自动扣款自动充值服务后再在本系统下单！"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "5，充值电费时，广东,广西,云南,贵州,海南请选择南网！其他地区请选择国网。"), _createElementVNode("p", null, [_createElementVNode("br")])])])], -1))]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}